export default __webpack_public_path__ + "static/media/billingIcon.31d6cfe0.svg";